import { Routes, Route } from 'react-router-dom';
import { AUTH_ROUTES } from '../components/modules/auth/routes';

const AuthLayout = () => {
    return (
        <Routes>
            {AUTH_ROUTES.map((v, key) => (
                <Route path={v.path} element={v.element} key={key} />
            ))}
        </Routes>
    );
};

export default AuthLayout;
